export const publicVersion = "2.6.1-0-g9f54b3a-2026-04-11T12-34-26Z";